import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {MatNativeDateModule} from '@angular/material/core';

import { AppComponent } from './app.component';

import { SidebarModule } from './sidebar/sidebar.module';
import { FooterModule } from './shared/footer/footer.module';
import { NavbarModule} from './shared/navbar/navbar.module';
import { FixedpluginModule} from './shared/fixedplugin/fixedplugin.module';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutes } from './app.routing';
import { AuthGuard } from './shared/guard/auth.guard';
import { AuthenticationService } from './shared/services/authentication.service';
import { HttpMethodService } from './shared/services/http-method.service';
import { ControlsService } from './shared/services/controls.service';
import { VariablesService } from './shared/services/variables.service';
import { InterceptorProviders } from './shared/interceptors/interceptors';
import { ListenerService } from './shared/services/listener.service';
import { NumberOnlyDirective } from './shared/directives/number-only.directive';
import { EasySpinnerModule } from './controls/easy-spinner/easy-spinner.module';
import { WebsocketService } from './shared/services/websocket.service';
import { RealTimeService } from './shared/services/real-time.service';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { MaterialModule } from './controls/material/material.module';
// import { ProjectSelectComponent } from './confirma-components/project-select/project-select.component';
// import { InputAdjuntosComponent } from './confirma-components/input-adjuntos/input-adjuntos.component';
// import { MapComponent } from './confirma-components/map/map.component';
// import { NotifierModule, NotifierOptions } from 'angular-notifier';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

// @NgModule({
//   exports: [
//     MatAutocompleteModule,
//     MatButtonModule,
//     MatButtonToggleModule,
//     MatCardModule,
//     MatCheckboxModule,
//     MatChipsModule,
//     MatStepperModule,
//     MatDatepickerModule,
//     MatDialogModule,
//     MatExpansionModule,
//     MatGridListModule,
//     MatIconModule,
//     MatInputModule,
//     MatListModule,
//     MatMenuModule,
//     MatNativeDateModule,
//     MatPaginatorModule,
//     MatProgressBarModule,
//     MatProgressSpinnerModule,
//     MatRadioModule,
//     MatRippleModule,
//     MatSelectModule,
//     MatSidenavModule,
//     MatSliderModule,
//     MatSlideToggleModule,
//     MatSnackBarModule,
//     MatSortModule,
//     MatTableModule,
//     MatTabsModule,
//     MatToolbarModule,
//     MatTooltipModule,
//     MatBadgeModule,
//     SharedModule,
//     NgxMatSelectSearchModule,
//     ScrollingModule
//   ]
//  // declarations: [ListaPrecioComponent]
// })
// export class MaterialModule {}

@NgModule({
    imports:      [
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        RouterModule.forRoot(AppRoutes,{
          useHash: true
        }),
        MaterialModule,
        MatNativeDateModule,
        SidebarModule,
        NavbarModule,
        FooterModule,
        FixedpluginModule,
        HttpClientModule,
        NgxSpinnerModule,
        EasySpinnerModule,
        NgxMaskModule.forRoot(maskConfig),
    ],
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        // ProjectSelectComponent,
        // InputAdjuntosComponent,
        // MapComponent
    ],
    providers: [
      AuthGuard,
      AuthenticationService,
      HttpMethodService,
      ControlsService,
      VariablesService,
      InterceptorProviders,
      ListenerService,
      NumberOnlyDirective,
      WebsocketService,
      RealTimeService
    ],
    bootstrap:    [ AppComponent ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class AppModule { }
